'use client';

import * as React from 'react';
/**
 * @ignore - internal component.
 */
var RadioGroupContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}
export default RadioGroupContext;